import $ from 'jquery'
import Canvg from 'canvg'
import Hammer from '@squadette/hammerjs'
import { SVG } from '@svgdotjs/svg.js'

import Bounds from '../math/Bounds'
import Vector from '../math/Vector'

const ZOOM_MAX = 10
const ZOOM_MIN = 0.1
const TAX = 19.0

export default class Diagram {
  extents = new Bounds()

  offset

  rotation

  zoomLevel

  side

  $wrapper

  $container

  svg

  data

  montage

  visible

  segments

  balconyThickness = 1

  wallThickness = 8

  angles

  plan

  balconyLine

  railingLine

  wallLine

  pan = new Vector()

  box = new Vector({ x: 100.0, y: 100 })

  boxPixels = new Vector()

  pinch = 1.0

  rotate = 0.0

  postCount = 0

  constructor($wrapper, side) {
    this.side = side
    this.$wrapper = $wrapper

    $wrapper.on('change', 'input.zusatzartikel__input', () => {
      this.updatePrice()
    })

    this.$container = $wrapper.find('.configurator-diagram__container')

    if (!this.$container.length) {
      return
    }

    this.svg = SVG().addTo(this.$container.get(0))
    this.svg.viewbox(0, 0, this.box.x, this.box.y)
    this.update({ visible: false, segments: [] })

    const hammer = new Hammer(this.svg.node)

    hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL })
    hammer.get('swipe').set({ enable: false })
    hammer.get('pinch').set({ enable: true })
    hammer.get('rotate').set({ enable: true })

    // Pan
    hammer.on('panmove', (e) => {
      this.pan = new Vector({ x: e.deltaX, y: e.deltaY })
      this.updateView()
    })

    hammer.on('panend', (e) => {
      this.pan = new Vector({ x: e.deltaX, y: e.deltaY })
      this.updateView({ acceptPan: true })
    })

    hammer.on('pancancel', () => {
      this.pan = new Vector()
      this.updateView()
    })

    // Pinch
    hammer.on('pinchmove', (e) => {
      this.pinch = e.scale
      this.updateView()
    })

    hammer.on('pinchend', (e) => {
      this.pinch = e.scale
      this.updateView({ acceptPinch: true })
    })

    hammer.on('pancancel', () => {
      this.pinch = 1.0
      this.updateView()
    })

    // Rotate
    hammer.on('rotatemove', (e) => {
      this.rotate = e.rotation
      this.updateView()
    })

    hammer.on('rotateend', (e) => {
      this.rotate = e.rotation
      this.updateView({ acceptRotate: true })
    })

    hammer.on('rotatecancel', () => {
      this.rotate = 0.0
      this.updateView()
    })

    // Buttons
    $wrapper.find('.configurator-diagram__zoomout').click(() => {
      this.zoomLevel = Math.max(ZOOM_MIN, this.zoomLevel / 1.2)
      this.updateView()
    })

    $wrapper.find('.configurator-diagram__zoomin').click(() => {
      this.zoomLevel = Math.min(ZOOM_MAX, this.zoomLevel * 1.2)
      this.updateView()
    })

    $wrapper.find('.configurator-diagram__ccw').click(() => {
      this.rotation = (this.rotation - 15) % 360
      this.updateView()
    })

    $wrapper.find('.configurator-diagram__cw').click(() => {
      this.rotation = (this.rotation + 15) % 360
      this.updateView()
    })

    $wrapper.find('.configurator-diagram__reset').click(() => {
      this.resetView()
    })

    // $wrapper.find('.configurator-diagram__download').click(() => {
    //   const a = document.createElement('a')
    //
    //   a.hreflang = 'image/svg+xml'
    //   a.download = 'diagramm.svg'
    //   a.href = `data:image/svg+xml;base64,${btoa(this.svg.node.outerHTML)}`
    //
    //   document.body.appendChild(a)
    //   a.click()
    //   document.body.removeChild(a)
    // })

    $wrapper.find('.configurator-diagram__download').click(async () => {
      const canvas = await this.svg2Png()
      const url = canvas.toDataURL('image/png')
      const a = document.createElement('a')

      a.hreflang = 'image/png'
      a.download = 'diagramm.png'
      a.href = url

      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    })
  }

  async svg2Png() {
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    const data = this.svg.node.outerHTML
    const v = await Canvg.fromString(ctx, data)

    v.resize(2048, 2048, 'xMidYMid')

    await v.render()

    return canvas
  }

  /**
   * Getting new parameters
   */
  update(data) {
    this.data = data
    this.montage = data.montage
    this.visible = data.visible
    this.segments = this.simplify(data.segments)
    this.extents.reset()

    if (!this.$container.length) {
      this.updatePrice()

      return
    }

    if (!this.visible || this.segments.length === 0) {
      this.renderUnavailable()
    } else {
      this.render()
    }
  }

  /**
   * Concatenate segments with angle 180, adjust negative angles
   */
  simplify(segments) {
    const result = []

    let l = 0

    for (const s of segments) {
      if (s.angle !== null) {
        if (s.angle > -80 && s.angle < 0) {
          s.angle = -80
        } else if (s.angle >= 0 && s.angle < 80) {
          s.angle = 80
        }

        if (s.angle < 0) {
          s.angle += 360
        }
      }

      if (s.angle === 180) {
        l += s.length
      } else {
        result.push({ length: s.length + l, angle: s.angle })
        l = 0
      }
    }

    return result
  }

  getPrice() {
    let price = 0.0
    let priceIncludingAdditional = 0.0
    let known = false

    const $additional = $('.zusatzartikel__input')

    $additional.each(function () {
      const $input = $(this)
      const p = $input.val() * +$input.data('price')

      priceIncludingAdditional += p
    })

    const data = $('.variations_form.cart').data('product_variations')
    const variationId = $('.variations_form [name="variation_id"]').val()

    if (!data) {
      return { price, priceIncludingAdditional, known }
    }

    price = data.reduce(
      (p, v) => (console.log(p, v), Math.min(p, v.display_price)),
      999999.99,
    )

    if (!variationId) {
      priceIncludingAdditional += price

      return { price, priceIncludingAdditional, known }
    }

    const variation = data.find((v) => v.variation_id === +variationId)

    if (!variation) {
      priceIncludingAdditional += price

      return { price, priceIncludingAdditional, known }
    }

    const hasSides = $('#sides-options').length > 0
    const displayPrice = +(variation.display_price ?? 0.0)
    const railingPrice = +(variation.railing_price ?? 0.0)
    const postPrice = +(variation.post_price ?? 0.0)
    const cornerPrice = +(variation.corner_price ?? 0.0)

    const lfm = Math.ceil(
      this.segments.reduce((sum, x) => x.length + sum, 0) / 100.0,
    )
    const corners = this.segments.length - 1

    known = !hasSides || corners >= 0
    price = hasSides
      ? (railingPrice * lfm +
          postPrice * this.postCount +
          cornerPrice * Math.max(0, corners)) *
        (1.0 + TAX / 100.0)
      : displayPrice

    priceIncludingAdditional += price

    return { price, priceIncludingAdditional, known }
  }

  updatePrice() {
    const { price, priceIncludingAdditional, known } = this.getPrice()
    const currency = document.createElement('span')

    currency.classList.add('woocommerce-Price-currencySymbol')
    currency.textContent = '€'

    const wrapper = document.createElement('span')

    $('#configurator-price').val(
      known ? price / (1.0 + TAX / 100.0) : 999999.99,
    )

    wrapper.classList.add('woocommerce-Price-amount', 'amount')
    wrapper.innerHTML = `${
      (known ? '' : 'ab ') +
      priceIncludingAdditional.toLocaleString('de-DE', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      })
    }&nbsp;`
    wrapper.appendChild(currency)

    $('.price-box .woocs_price_code').empty().append(wrapper)
  }

  renderUnavailable() {
    this.svg.clear()
    this.svg.rect('100%', '100%').fill('#fff')
    this.plan = null
    this.svg
      .viewbox(0, 0, this.box.x, this.box.y)
      .text(
        'Bitte wählen Sie Montage, Geländerform und\nMaße für die Anzeige des Grundrisses!',
      )
      .move(0.5 * this.box.x, 0.4 * this.box.y)
      .font({ anchor: 'middle', size: 4 })
    this.updatePrice()
  }

  render() {
    // reset
    this.extents.reset()
    this.svg.clear()
    this.svg.rect('100%', '100%').fill('#fff')
    this.plan = this.svg.group()

    this.createLines()
    this.createWalls()
    this.renderBalcony()
    this.renderPosts()
    this.resetView()
    this.updatePrice()
  }

  createLines() {
    const railingDistance = this.montage === 'seitlich' ? -5 : 10

    let angle = 0
    let balcony = new Vector()
    let railing = balcony.move(railingDistance, angle - 90)

    this.balconyLine = [balcony]
    this.railingLine = [railing]
    this.angles = [angle]

    for (const segment of this.segments) {
      balcony = balcony.move(segment.length, angle)
      railing = balcony.move(railingDistance, angle - 90)

      if (segment.angle) {
        railing = railing.move(
          railingDistance *
            Math.tan(((segment.angle - 180.0) * Math.PI) / 180.0 / 2),
          angle,
        )

        angle = (angle + segment.angle - 180) % 360
      }

      this.balconyLine.push(balcony)
      this.railingLine.push(railing)
      this.angles.push(angle)
    }

    this.extents.addPoints(this.balconyLine)
    this.extents.addPoints(this.railingLine)
  }

  renderMarkers(
    start,
    end,
    angle,
    { isFirst = false, renderText = true } = {},
  ) {
    const renderMarker = (position) => {
      this.plan
        .line(Vector.toArrays([position, position.move(4, angle + 90)]))
        .fill('none')
        .stroke({ width: 0.5, color: '#666' })
    }

    if (isFirst) {
      renderMarker(start)
    }

    renderMarker(end)

    if (renderText) {
      const t = this.plan.group().transform({
        origin: 'top center',
        translate: start.midpoint(end),
        rotate: -angle,
      })

      t.plain(
        `${start
          .distance(end)
          .toLocaleString('de-DE', { maximumFractionDigits: 2 })} cm`,
      )
        .attr('x', 0)
        .attr('y', this.montage === 'seitlich' ? -9 : -5)
        .fill('rgba(0, 0, 0, 0.75)')
        .font({ anchor: 'middle', size: 4.5 })
    }
  }

  postDistances(i) {
    let startDistance = 30
    let endDistance = 30

    if (i === 0) {
      startDistance = 12
    } else if (
      this.montage === 'seitlich' &&
      this.segments[i - 1].angle <= 180
    ) {
      startDistance = 20
    }

    if (i >= this.railingLine.length - 2) {
      endDistance = 12
    } else if (this.montage === 'seitlich' && this.segments[i].angle <= 180) {
      endDistance = 20
    }

    return { startDistance, endDistance }
  }

  renderPosts() {
    this.postCount = 0

    for (let i = 0; i < this.balconyLine.length - 1; i++) {
      const start = this.balconyLine[i]
      const end = this.balconyLine[i + 1]
      const angle = this.angles[i]
      const segmentLength = start.distance(end)

      if (segmentLength < 30) {
        // no posts can be placed
        this.renderMarkers(start, end, { isFirst: true, renderText: false })
      } else if (segmentLength < 60) {
        // place a single centered post
        const midpoint = start.midpoint(end)

        this.renderMarkers(start, midpoint, angle, { isFirst: true })
        this.renderMarkers(midpoint, end, angle)
        this.renderPost(midpoint, angle)
        this.postCount++
      } else {
        // multiple posts
        const { startDistance, endDistance } = this.postDistances(i)

        const startPost = start.move(startDistance, angle)
        const endPost = end.move(-endDistance, angle)

        const distance = startPost.distance(endPost)
        const postCount = Math.ceil(distance / 100)
        const delta = 1.0 / postCount

        this.renderMarkers(start, startPost, angle, { isFirst: true })
        this.renderPost(startPost, angle)
        this.postCount++

        for (let lastPost = startPost, posts = 1; posts <= postCount; posts++) {
          const currentPost = startPost.interpolate(endPost, posts * delta)

          this.renderMarkers(lastPost, currentPost, angle)
          this.renderPost(currentPost, angle)
          this.postCount++

          lastPost = currentPost
        }

        this.renderMarkers(endPost, end, angle)
      }
    }
  }

  createWalls() {
    const first = this.balconyLine[0]
    const last = this.balconyLine[this.balconyLine.length - 1]
    const exitAngle = this.angles[this.angles.length - 1]

    if (exitAngle > 0.0) {
      const nw = first.add({
        x: -0.5 * this.wallThickness,
        y: -0.5 * this.balconyThickness,
      })
      const ne = last.add({
        x: 0,
        y: -0.5 * this.wallThickness,
      })
      const nee = ne.add({ x: 30, y: 0 })
      const s = this.extents.se.y + 20

      this.wallLine = [
        ne,
        nee,
        new Vector({ x: nee.x, y: s }),
        new Vector({ x: nw.x, y: s }),
        nw,
      ]
    } else if (exitAngle > -90.0) {
      const nw = first.add({
        x: -0.5 * this.wallThickness,
        y: -0.5 * this.balconyThickness,
      })
      const ne = last.add({
        x: 0.5 * this.wallThickness,
        y: -0.5 * this.balconyThickness,
      })
      const s = this.extents.se.y + 20

      this.wallLine = [
        ne,
        new Vector({ x: ne.x, y: s }),
        new Vector({ x: nw.x, y: s }),
        nw,
      ]
    } else if (exitAngle > -180) {
      const nw = first.sub({
        x: 0.5 * this.wallThickness,
        y: 0.5 * this.balconyThickness,
      })
      const ne = last.add({
        x: 0.5 * this.balconyThickness,
        y: 0.5 * this.wallThickness,
      })

      if (ne.x - this.wallThickness < nw.x) {
        const sw = new Vector({ x: ne.x - 4 * this.wallThickness, y: ne.y })

        this.wallLine = [
          ne,
          sw,
          new Vector({ x: sw.x, y: (sw.y + nw.y) / 2 }),
          new Vector({ x: nw.x, y: (sw.y + nw.y) / 2 }),
          nw,
        ]
      } else {
        this.wallLine = [ne, new Vector({ x: nw.x, y: ne.y }), nw]
      }
    } else {
      const nw = first.add({
        x: -0.5 * this.wallThickness,
        y: -0.5 * this.balconyThickness,
      })
      const sw = last.add({
        x: -0.5 * this.wallThickness,
        y: 0.5 * this.balconyThickness,
      })

      if (nw.x === sw.x) {
        this.wallLine = [sw, nw]
      } else {
        this.wallLine = [
          sw,
          new Vector({ x: sw.x, y: (sw.y + nw.y) / 2 }),
          new Vector({ x: nw.x, y: (sw.y + nw.y) / 2 }),
          nw,
        ]
      }
    }

    this.extents.addPoints(this.wallLine)
  }

  renderPost(post, angle) {
    const p = this.plan.group().transform({
      origin: 'top center',
      translate: post,
      rotate: -angle,
    })

    const r = 2.5

    if (this.montage === 'seitlich') {
      p.rect(3, 5).move(-1.5, -5).fill('#fff').stroke('#000')
      p.rect(2 * r, 1)
        .move(-r, -1)
        .fill('#fff')
        .stroke('#000')
      p.circle(2 * r)
        .move(-r, -5 - r)
        .fill('#fff')
        .stroke('#000')
    } else {
      p.circle(2 * r)
        .move(-r, 10 - r)
        .fill('#fff')
        .stroke('#000')
    }
  }

  renderBalcony() {
    // floor
    this.plan
      .polygon(Vector.toArrays([...this.balconyLine, ...this.wallLine]))
      .fill('#f0f0f0')
      .stroke('none')

    // walls
    this.plan
      .polyline(Vector.toArrays(this.wallLine))
      .fill('none')
      .stroke({ width: this.wallThickness, color: '#666' })

    // balcony
    this.plan
      .polyline(Vector.toArrays(this.balconyLine))
      .fill('none')
      .stroke({ width: this.balconyThickness, color: '#666' })

    // balcony - distance to railing
    for (let i = 0; i < this.balconyLine.length - 1; i++) {
      if (i > 0) {
        // for now, only render the first distance
        break
      }

      const dr = this.montage === 'seitlich' ? 5 : 10

      let start = this.balconyLine[i].move(
        Math.min(this.segments[i].length / 2, 35),
        this.angles[i],
      )

      if (this.montage === 'seitlich') {
        start = start.move(-dr, this.angles[i] - 90)
      }

      const balconyDistanceGroup = this.plan.group().transform({
        origin: 'bottom left',
        translate: start,
        rotate: -this.angles[i],
      })

      balconyDistanceGroup
        .line([
          [0, 0],
          [0, dr],
        ])
        .fill('none')
        .stroke({ width: 0.5, color: '#666' })
      balconyDistanceGroup
        .plain(`${dr.toLocaleString('de-DE', { maximumFractionDigits: 2 })} cm`)
        .attr('x', 1)
        .attr('y', (dr * 2.0) / 3.0)
        .fill('#333')
        .font({ size: 3 })
    }

    // balcony - lengths
    for (let i = 0; i < this.balconyLine.length - 1; i++) {
      const start = this.balconyLine[i]
      const end = this.balconyLine[i + 1]
      const midpoint = start.midpoint(end)
      const angle = this.angles[i]
      /** @type Number */
      const l = this.segments[i].length

      this.plan
        .plain(`${l.toLocaleString('de-DE', { maximumFractionDigits: 2 })} cm`)
        .attr('x', midpoint.x)
        .attr('y', midpoint.y)
        .fill('#000')
        .font({ anchor: 'middle', size: 6 })
        .transform({
          origin: 'top center',
          translateY: 6,
          theta: -angle,
          relative: true,
        })
    }

    // balcony - angles
    for (let i = 1; i < this.balconyLine.length - 1; i++) {
      const r = 8
      const start = this.balconyLine[i].move(-r, this.angles[i - 1])
      const end = this.balconyLine[i].move(r, this.angles[i])
      const angle =
        (this.angles[i] >= this.angles[i - 1] ? 180 : 0) +
        (this.angles[i - 1] + this.angles[i]) / 2

      this.plan
        .path(
          `M${start.x} ${start.y} A${r} ${r} 0 ${
            this.segments[i - 1].angle >= 180 ? 1 : 0
          } 0 ${end.x} ${end.y}`,
        )
        .fill('none')
        .stroke({ color: '#333', width: 0.5 })

      const labelGroup = this.plan.group().transform({
        origin: 'top center',
        translate: this.balconyLine[i],
        rotate: (this.segments[i - 1].angle > 180 ? 180 : 0) - angle,
      })

      if (this.segments[i - 1].angle === 90) {
        labelGroup
          .circle(1.5)
          .move(-0.75, -0.75 + r / 2)
          .fill('#333')
          .stroke('none')
      } else {
        labelGroup
          .plain(
            `${this.segments[i - 1].angle.toLocaleString('de-DE', {
              maximumFractionDigits: 2,
            })}°`,
          )
          .attr('x', 0)
          .attr('y', 0)
          .fill('#333')
          .font({ anchor: 'middle', size: 3 })
          .transform({ translateY: r * 0.75 }, true)
      }
    }

    // railing
    this.plan
      .polyline(Vector.toArrays(this.railingLine))
      .fill('none')
      .stroke({ width: 1, color: '#000' })
  }

  resetView() {
    const extents = this.extents.extend({ x: 20, y: 20 })
    const size = extents.size()
    const maxDimension = Math.max(size.x, size.y)

    this.zoomLevel = Math.min(this.box.x, this.box.y) / maxDimension
    this.offset = extents
      .center()
      .scale(-this.zoomLevel)
      .add(this.box.scale(0.5))
    this.rotation = 0

    this.updateView()
  }

  updateView({
    acceptPan = false,
    acceptPinch = false,
    acceptRotate = false,
  } = {}) {
    const rect = this.svg.node.getBoundingClientRect()

    this.boxPixels = new Vector({ x: rect.width, y: rect.height })

    const offset = this.getOffset()
    const zoom = this.getZoom()
    const rotation = this.getRotation()

    if (acceptPan) {
      this.pan = new Vector()
      this.offset = offset
    }

    if (acceptPinch) {
      this.zoomLevel = zoom
      this.pinch = 1.0
    }

    if (acceptRotate) {
      this.rotation = rotation
      this.rotate = 0.0
    }

    if (this.plan) {
      const center = this.extents.center()

      this.plan.attr(
        'transform',
        `translate(${offset.x} ${offset.y}) scale(${zoom}) rotate(${rotation} ${center.x} ${center.y})`,
      )
    }
  }

  getRotation() {
    // TODO: Rotate around center
    return Math.floor(((this.rotation + this.rotate) % 360) / 15.0 + 0.5) * 15
  }

  getZoom() {
    // TODO: Better clamping
    return Math.min(5.0, Math.max(0.1, this.zoomLevel * this.pinch))
  }

  getOffset() {
    // TODO: Better clamping
    const padding = 20
    const result = this.offset
      .add(
        this.pan.scale(
          this.box.x / this.boxPixels.x,
          this.box.y / this.boxPixels.y,
        ),
      )
      .clamp(
        new Vector({
          x: padding - this.extents.se.x,
          y: padding - this.extents.se.y,
        }),
        new Vector({
          x: this.box.x - this.extents.nw.x - padding,
          y: this.box.y - this.extents.nw.y - padding,
        }),
      )

    return result
  }
}
